import { atom } from 'recoil';

const menuState = atom({
  key: 'menu',
  default: false,
});

export default menuState;
